module.exports = __webpack_public_path__ + "img/revenues-Savings.58b464ea.png";